﻿import common from "../../common";
import context_ from "../context";
import SearchBox_ from "../../core/SearchBox";

const context = require("../context") as typeof context_;
// const SearchBox = require("../../core/SearchBox") as SearchBox_;

interface ISettings {
    /** Settings du searchbox (requis si "enableSearchBox" vaut TRUE) */
    searchBoxSettingsLeft?: common.ISearchBoxSettings;
    searchBoxSettingsRight?: common.ISearchBoxSettings;
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs des filtres du searchbox */
    filtersFormName?: string;
    commonCustomData: common.IPostCustomData;
}

enum SearchBoxSections {
    left = 'left',
    right = 'right'
}

class DefaultTransfertSearchBoxes implements common.IWebComponent {
    private _isInit = false;
    searchBoxLeft?: SearchBox_;
    searchBoxRight?: SearchBox_;
    protected readonly _defaultFiltersFormName = 'DefaultSearchBoxFilters';

    init(s: ISettings) {
        if (this._isInit)
            return this;
        this._isInit = true;

        this.setupSearchBoxes(s.searchBoxSettingsLeft, s.searchBoxSettingsRight, s.commonCustomData, s.filtersFormName);

        return context.components.add(this);
    }

    private setupSearchBoxes(searchBoxSettingsLeft?: common.ISearchBoxSettings, searchBoxSettingsRight?: common.ISearchBoxSettings, commonCustomData?: common.IPostCustomData, filtersFormName?: string) {

        if (!searchBoxSettingsLeft)
            throw "L'argument 'searchBoxSettings' est requis car la propriete 'isEnabledSearchBox' est TRUE.";

        filtersFormName = filtersFormName || filtersFormName === null ? filtersFormName : this._defaultFiltersFormName;

        const pooler = context.components.getPooler();

        if (commonCustomData) {
            SearchBox_.ensureCustomDataPropertyIsValid(searchBoxSettingsLeft);
            SearchBox_.ensureCustomDataPropertyIsValid(searchBoxSettingsRight);
            SearchBox_.transfertCustomData(commonCustomData, searchBoxSettingsLeft.customData);
            SearchBox_.transfertCustomData(commonCustomData, searchBoxSettingsRight?.customData);
        }

        this.searchBoxLeft = new SearchBox_(searchBoxSettingsLeft, filtersFormName, pooler);
        this.searchBoxRight = new SearchBox_(searchBoxSettingsRight, filtersFormName, pooler);

        this.searchBoxLeft.setOnPerformActionSuccessCallback(focusedItemId => {
            this.onPerformActionSuccessCallback(SearchBoxSections.left, focusedItemId);
        });
        this.searchBoxRight.setOnPerformActionSuccessCallback(focusedItemId => {
            this.onPerformActionSuccessCallback(SearchBoxSections.right, focusedItemId);
        });
    }

    private onPerformActionSuccessCallback(section: SearchBoxSections, focusedItemId?: string | null) {
        focusedItemId = focusedItemId || null;

        if (section === SearchBoxSections.left)
            this.searchBoxRight?.refresh(focusedItemId);
        else
            this.searchBoxLeft?.refresh(focusedItemId);
    }
}

export = DefaultTransfertSearchBoxes;
